import { Link } from 'react-router-dom';
import VideoCard from '@/components/base/VideoCard';
import { videos } from '@/mocks/data';

export default function LatestUpdates() {
  const latest = [...videos].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()).slice(0, 8);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-2">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500">每日更新 · 精彩内容不停歇</p>
          </div>
          <Link to="/category/latest" className="text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap">
            更多 <i className="ri-arrow-right-line ml-1 text-xs"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-5" data-product-shop>
          {latest.map((video) => (
            <VideoCard
              key={video.id}
              id={video.id}
              title={video.title}
              slug={video.slug}
              thumbnail={video.thumbnail}
              duration={video.duration}
              categoryName={video.categoryName}
              views={video.views}
              date={video.date}
              rating={video.rating}
            />
          ))}
        </div>
      </div>
    </section>
  );
}